import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { getScanHistory, getSelectedEvent, pushScanHistory, setSelectedEvent as persistEvent } from 'shared/util/storage'

const EventContext = createContext({
  event: null,
  eventId: null,
  setEvent: () => {},
  scanHistory: [],
  addScanHistory: () => {},
  lastScan: null,
  setLastScan: () => {}
})

export function EventProvider({ eventId, children }) {
  const stored = getSelectedEvent()
  const [event, setEventState] = useState(() => (stored && String(stored._id) === String(eventId) ? stored : { _id: eventId }))
  const [scanHistory, setScanHistory] = useState(() => getScanHistory(eventId))
  const [lastScan, setLastScan] = useState(null)

  const setEvent = useCallback((next) => {
    setEventState(next)
    persistEvent(next)
  }, [])

  const addScanHistory = useCallback(
    (item) => {
      setScanHistory(pushScanHistory(eventId, item))
    },
    [eventId]
  )

  const value = useMemo(
    () => ({
      event,
      eventId,
      setEvent,
      scanHistory,
      addScanHistory,
      lastScan,
      setLastScan
    }),
    [event, eventId, setEvent, scanHistory, addScanHistory, lastScan]
  )

  return <EventContext.Provider value={value}>{children}</EventContext.Provider>
}

EventProvider.propTypes = {
  eventId: PropTypes.string,
  children: PropTypes.node
}

export function useEvent() {
  return useContext(EventContext)
}
